import React, { useEffect, useState } from 'react';
import BarChart from '../../core/Components/Barchart';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { useTranslation } from '../../core';
import { DateRangePicker } from "../../core/Components/DateRange";
import { addDays } from 'date-fns';
import { useSelector } from 'react-redux';
import * as dashboardSelectors from '../selectors';
import { getGoodsInData } from '../actions';
import _ from 'lodash';
import useAction from '../../core/services/UseAction';
import ChartContainer from '../../core/Components/ChartContainer';
import { withoutNullValue } from '../../core/services/chartDataFilter';


const GoodsDataDashboard = () => {

  const { t } = useTranslation();

  const [selection, setSelection] = useState(
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: 'selection',
    }
  )
  const [usersSelection, setUserSelection] = useState([]);


  const getData = useAction(() =>getGoodsInData(selection.startDate, selection.endDate), [selection]);
  const data = useSelector(dashboardSelectors.doodsInData);
  const isLoadingGoodsInData = useSelector(dashboardSelectors.isLoadingGoodsInData);

  useEffect(() => {
    getData();
  }, [selection])

  const onDateRangeChange = (which) => {
    setSelection(which.selection)
  }

  const onUserSelection = (userName) => {
    if (_.find(usersSelection, elem => elem === userName)) {
      setUserSelection(_.filter(usersSelection, i => i !== userName))
    } else {
      setUserSelection([...usersSelection, userName])
    }
  }


  // const data = [
  //   {
  //     "userName": "User1",
  //     "itemsBookedinPerHour": 0,
  //     "itemsBooked": 3,
  //     "itemsMoved": 5,
  //     "itemsMovedPerHour": 1,
  //     "hours": 25,
  //   },
  //   {
  //     "userName": "User2",
  //     "itemsBookedinPerHour": 23,
  //     "itemsBooked": 8,
  //     "itemsMoved": 4,
  //     "itemsMovedPerHour": 4,
  //     "hours": 0
  //   },
  //   {
  //     "userName": "User3",
  //     "itemsBookedinPerHour": 5,
  //     "itemsBooked": 1,
  //     "itemsMoved": 5,
  //     "itemsMovedPerHour": 2,
  //     "hours": 20
  //   },
  //   {
  //     "userName": "User4",
  //     "itemsBookedinPerHour": 40,
  //     "itemsBooked": 6,
  //     "itemsMoved": 10,
  //     "itemsMovedPerHour": 4,
  //     "hours": 12
  //   },
  //   {
  //     "userName": "User5",
  //     "itemsBookedinPerHour": 5,
  //     "itemsBooked": 0,
  //     "itemsMoved": 5,
  //     "itemsMovedPerHour": 4,
  //     "hours": 36
  //   },
  //   {
  //     "userName": "User6",
  //     "itemsBookedinPerHour": 0,
  //     "itemsBooked": 2,
  //     "itemsMoved": 6,
  //     "itemsMovedPerHour": 4,
  //     "hours": 40
  //   }, {
  //     "userName": "User7",
  //     "itemsBookedinPerHour": 12,
  //     "itemsBooked": 2,
  //     "itemsMoved": 3,
  //     "itemsMovedPerHour": 1,
  //     "hours": 38
  //   },
  //   {
  //     "userName": "User8",
  //     "itemsBookedinPerHour": 18,
  //     "itemsBooked": 6,
  //     "itemsMoved": 2,
  //     "itemsMovedPerHour": 1,
  //     "hours": 80
  //   },
  //   {
  //     "userName": "User9",
  //     "itemsBookedinPerHour": 40,
  //     "itemsBooked": 10,
  //     "itemsMoved": 18,
  //     "itemsMovedPerHour": 5,
  //     "hours": 21
  //   },
  //   {
  //     "userName": "User10",
  //     "itemsBookedinPerHour": 35,
  //     "itemsBooked": 4,
  //     "itemsMoved": 30,
  //     "itemsMovedPerHour": 6,
  //     "hours": 8
  //   },
  //   {
  //     "userName": "User11",
  //     "itemsBookedinPerHour": 23,
  //     "itemsBooked": 6,
  //     "itemsMoved": 0,
  //     "itemsMovedPerHour": 4,
  //     "hours": 34
  //   },
  //   {
  //     "userName": "User12",
  //     "itemsBookedinPerHour": 37,
  //     "itemsBooked": 14,
  //     "itemsMoved": 3,
  //     "itemsMovedPerHour": 6,
  //     "hours": 36
  //   },
  //   {
  //     "userName": "User13",
  //     "itemsBookedinPerHour": 14,
  //     "itemsBooked": 3,
  //     "itemsMoved": 8,
  //     "itemsMovedPerHour": 3,
  //     "hours": 10
  //   },
  //   {
  //     "userName": "User14",
  //     "itemsBookedinPerHour": 12,
  //     "itemsBooked": 4,
  //     "itemsMoved": 23,
  //     "itemsMovedPerHour": 12,
  //     "hours": 18
  //   }
  // ]

  return (
    <Grid fluid className="dashboardContainer">
      <Row className="dashboardHeader">
        <Col xs>
          <DateRangePicker
            onChange={onDateRangeChange}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            className={'PreviewArea'}
            months={3}
            ranges={[selection]}
            direction="horizontal"
          />
        </Col>
      </Row>
      <ChartContainer>
        <BarChart
          indexBy={'userName'}
          data={withoutNullValue(data, 'itemsBookedPerHour')}
          loading={isLoadingGoodsInData}
          title={t("goodsInData.fields.itemsBookedinPerHour")}
          keys={['itemsBookedPerHour']}
          textDisplayKey="userName"
          onUserSelection={onUserSelection}
          usersSelection={usersSelection}
        />
      </ChartContainer>
      <ChartContainer>
        <BarChart
          indexBy={'userName'}
          data={withoutNullValue(data, 'itemsBooked')}
          loading={isLoadingGoodsInData}
          title={t("goodsInData.fields.itemsBookedIn")}
          keys={['itemsBooked']}
          textDisplayKey="userName"
          onUserSelection={onUserSelection}
          usersSelection={usersSelection}
        />
      </ChartContainer>
      <ChartContainer>
        <BarChart
          indexBy={'userName'}
          data={withoutNullValue(data, 'hours')}
          loading={isLoadingGoodsInData}
          title={t("goodsInData.fields.hours")}
          keys={['hours']}
          textDisplayKey="userName"
          onUserSelection={onUserSelection}
          usersSelection={usersSelection}
        />
      </ChartContainer>
    </Grid>
  );
};

export default GoodsDataDashboard;